import { render, staticRenderFns } from "./ContinueOrderAfterLogin.vue?vue&type=template&id=181a3f50&scoped=true"
import script from "./ContinueOrderAfterLogin.vue?vue&type=script&lang=js"
export * from "./ContinueOrderAfterLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a3f50",
  null
  
)

export default component.exports